import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";

const AccessLogsDashboard = Loadable(
  lazy(() =>
    import("./AccessLogsDashboard").then(({ AccessLogsDashboard }) => ({
      default: AccessLogsDashboard,
    }))
  )
);

const BankingLogsPage = Loadable(
  lazy(() =>
    import("./components/BankingLogsPage").then(({ BankingLogsPage }) => ({
      default: BankingLogsPage,
    }))
  )
);

export const accessLogsRoutes = [
  {
    path: "/settings/access-logs",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <AccessLogsDashboard />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/settings/access-logs/banking-logs",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <BankingLogsPage />
      </AuthorizedRoute>
    ),
  },
];
